
import pluginVoip from '@/assets/img/plugin-voip.png';
import pluginAd from '@/assets/img/plugin-ad.png';
import pluginHelpical from '@/assets/img/plugin-helpical.png';
import pluginMelipayamak from '@/assets/img/plugin-melipayamak.png';
import pluginKavenegar from '@/assets/img/plugin-kavehnegar.png';
import pluginSmsir from '@/assets/img/plugin-smsir.png';
import pluginMagfa from '@/assets/img/plugin-sms-magfa.png';
import pluginUrl from '@/assets/img/plugin-sms-url.png';
import pluginCrisp from '@/assets/img/plugin-crisp.png';
import pluginGoftino from '@/assets/img/plugin-goftino.png';
import pluginRaychat from '@/assets/img/plugin-raychat.png';

export default () => {
  const system = useSystemStore();
  return [
    {
      'icon': pluginVoip,
      'name': 'استریسک',
      'slug': 'asterisk',
      'category': 1,
      'accessConfig': system.license.features.voip,
      'config': [
        {
          'id': 1,
          'name': 'voip_active',
          'type': 'checkbox',
          'order': 0,
          'label': 'فعال سازی افزونه',
        },
        {
          'id': 2,
          'name': 'voip_province_code',
          'type': 'text',
          'order': 1,
          'label': 'پیش شماره استانی',
        },
        {
          'id': 3,
          'name': 'voip_secret_key',
          'type': 'uuid',
          'order': 2,
          'label': 'کلید محرمانه ارتباط با Voip',
        },
        {
          'id': 4,
          'name': 'voip_server_url',
          'type': 'url',
          'order': 3,
          'label': 'آدرس URL ارتباط با سرور Voip',
        },
      ],
      'values': [
        {
          'id': 1,
          'value': system.settings.voip_active,
        },
        {
          'id': 2,
          'value': system.settings.voip_province_code,
        },
        {
          'id': 3,
          'value': system.settings.voip_secret_key,
        },
        {
          'id': 4,
          'value': system.settings.voip_server_url,
        },
      ],
      'excerpt': 'استریسک بستر نرم افزاری استفاده از VoIP است که راهکارهایی نظیر Issable و FreePBX نیز بر اساس آن طراحی شده اند.',
      'configuration': 'برای ارتباط هلپیکال با افزونه استریسک، نیاز است تا یک کلید محرمانه برای این ارتباط ایجاد نموده و آنرا بر روی فایل تنظیمات افزونه که در سرور شما قرار خواهد گرفت درج نمایید.',
      'description': 'استریسک (Asterisk) یک نرم‌افزار سیستم تلفنی مبتنی بر اینترنت (IP PBX) متن‌باز (Open Source) است که برای پیاده‌سازی سیستم‌های تلفنی در سازمان‌ها و شرکت‌ها، ارائه خدمات تلفنی به صورت شبکه و کنترل ترافیک تماس‌ها استفاده می‌شود. استریسک قابلیت‌های متنوعی از جمله تماس‌های داخلی و بین‌المللی، تماس‌های صوتی و تصویری، سامانه پیام‌رسانی صوتی (IVR)، سیستم پیگیری تماس‌ها، تماس‌های همزمان، کنفرانس تلفنی و ... را داراست. همچنین استریسک به صورت گسترده در سیستم‌های تلفنی شرکتی و سازمانی و در برنامه‌های تجاری و صنعتی استفاده می‌شود. استفاده از نرم‌افزار استریسک می‌تواند برای سازمان‌ها و شرکت‌ها در پیاده‌سازی سیستم‌های تلفنی هوشمند، بهبود روند کاری و کاهش هزینه‌های تلفنی مؤثر باشد.<br /> برای استفاده از ویژگی های VoIP در بستر هلپیکال، باید دارای یک سرور مجهز به Asterisk بوده و افزونه هلپیکال توسط تیم فنی ما بر روی سرور شما نصب گردیده باشد.<br />برای استفاده از این افزونه دو روش در پیش رو شما وجود دارد. در حالت اول می توانید با استفاده از راهنمای API هلیپکال پیاده سازی ارتباط سرور ویپ خود با هلپیکال را انجام دهید. چنانچه انجام این کار توسط شما امکان پذیر نمی باشد، میتوانید با خرید افزونه استریسک از هلپیکال امکان ارتباط سرور ویپ خود با این سامانه را ایجاد نمایید.<br /><br /> <span class="font-weight-bold">قیمت افزونه: رایگان</span>',
      'permissions': 'افزونه استریسک برای نمایش اطلاعات تماس گیرنده بر روی سامانه هلپیکال به اطلاعات زیر در پایگاه داده دسترسی خواهد داشت.\n\n- اطلاعات کاربری مشتریان، کاربران سازمانی و مدیران'
    },
    {
      'icon': pluginAd,
      'name': 'اکتیو دایرکتوری',
      'slug': 'active-directory',
      'category': 3,
      'accessConfig': system.license.features.active_directory,
      'config': [
        {
          'id': 1,
          'name': 'ad_url',
          'type': 'url',
          'order': 0,
          'label': 'IP یا آدرس URL سرور',
        },
        {
          'id': 2,
          'name': 'ad_port',
          'type': 'number',
          'order': 1,
          'label': 'شماره پورت',
        },
        {
          'id': 3,
          'name': 'ad_username_prefix',
          'type': 'text',
          'order': 2,
          'label': 'پیشوند نام کاربری',
        },
        {
          'id': 4,
          'name': 'ad_username_suffix',
          'type': 'text',
          'order': 3,
          'label': 'پسوند نام کاربری',
        },
      ],
      'values': [
        {
          'id': 1,
          'value': system.settings.ad_url,
        },
        {
          'id': 2,
          'value': system.settings.ad_port,
        },
        {
          'id': 3,
          'value': system.settings.ad_username_prefix,
        },
        {
          'id': 4,
          'value': system.settings.ad_username_suffix,
        },
      ],
      'excerpt': 'اکتیو دایرکتوری یکی از راهکارهای مدیریت کاربران در شبکه های کامپیوتری است. این پلاگین امکان احراز هویت کاربران هلپیکال با این بستر را فراهم می آورد.',
      'configuration': 'برای اتصال هلپیکال به اکتیودایرکتوری سازمان، مشخصات سرور خود را وارد کنید. دقت فرمایید که در بخش حساب های کاربری قسمت تنظیمات نیز می باید احراز هویت کاربران خود را بر روی مدل اکتیودایرکتوری قرار داده باشید.',
      'description': 'اکتیو دایرکتوری یک سرویس است که توسط مایکروسافت توسعه یافته و برای شبکه‌های ویندوزی طراحی شده است. این سرویس به سازمان‌ها کمک می‌کند تا به صورت متمرکز، منابع شبکه‌ای خود مانند کاربران، کامپیوترها، چاپگرها، و سرویس‌ها را مدیریت و سازماندهی کنند. Active Directory از طریق یک ساختار سلسله‌مراتبی، امکان مدیریت بهتر و امن‌تر اطلاعات و منابع را فراهم می‌کند. در افزونه اکتیو دایرکتوری هلپیکال این امکان در اختیار شما قرار می گیرد تا بتوانید احراز هویت مشتریان و کاربران سازمانی خود را مبتنی بر نام کاربری و کلمه عبور حساب کاربری ایشان در سرور ویندوزی سازمان انجام دهید.',
      'permissions': 'افزونه اکتیو دایرکتوری جهت احراز هویت کاربران به اطلاعات زیر در پایگاه داده دسترسی خواهد داشت.\n\n- اطلاعات کاربری مشتریان، کاربران سازمانی و مدیران'
    },
    {
      'icon': pluginHelpical,
      'name': 'هلپیکال (ارسال بدون الگو)',
      'slug': 'helpical',
      'category': 2,
      'accessConfig': true,
      'config': [
        {
          'id': 1,
          'name': 'sms_helpical_username',
          'type': 'text',
          'order': 0,
          'label': 'نام کاربری',
        },
        {
          'id': 2,
          'name': 'sms_helpical_password',
          'type': 'password',
          'order': 1,
          'label': 'کلمه عبور',
        },
        {
          'id': 3,
          'name': 'sms_helpical_number',
          'type': 'text',
          'order': 2,
          'label': 'شماره خط پیامکی',
        },
      ],
      'values': [
        {
          'id': 1,
          'value': system.settings.sms_helpical_username,
        },
        {
          'id': 2,
          'value': system.settings.sms_helpical_password,
        },
        {
          'id': 3,
          'value': system.settings.sms_helpical_number,
        },
      ],
      'website': 'https://sms.parniagroup.ir',
      'excerpt': 'اگر تا کنون از سرویس های پیامکی استفاده نکرده اید، پیشنهاد می کنیم تا از سامانه پیامکی هلپیکال به عنوان مکانیزم ارتباطی پیامکی خود در این سامانه استفاده نمایید.',
      'configuration': 'برای فعال سازی افزونه پیامکی هلپیکال لطفا اطلاعات زیر را طبق جزئیات پنل پیامکی خود وارد نموده و دکمه ثبت اطلاعات را بفشارید. پس از این کار، می توانید پنل پیامکی هلپیکال را در بخش تنظیمات عمومی از قسمت اطلاع رسانی سامانه هلپیکال انتخاب نمایید.',
      'description': 'ارسال پیامک های اطلاع رسانی یکی از ویژگی های مهم هلپیکال است که شما را از اطلاع کاربران در خصوص رویدادهای مختلف این سامانه مطمئن خواهد نمود. اگر سامانه پیامکی خود را از مجموعه هلپیکال تهیه نموده اید، به راحتی می توانید در بخش تنظیمات این افزونه، پنل پیامکی خود را با نرم افزار هلپیکال مرتبط نمایید. چنانچه تا کنون سرویس پیامکی را برای مجموعه خود خریداری ننموده اید،  برای تهیه سامانه پیامکی هلپیکال روی لینک وبسایت کلیک کنید.<br /><br /> <span class="font-weight-bold">قیمت افزونه: رایگان</span>',
      'permissions': 'افزونه پیامکی هلپیکال برای ارسال اطلاعیه های پیامکی سامانه هلپیکال به اطلاعات زیر در پایگاه داده دسترسی خواهد داشت.\n\n- اطلاعات کاربری مشتریان، کاربران سازمانی و مدیران\n- جزئیات تیکت ها'
    },
    {
      'icon': pluginMelipayamak,
      'name': 'ملی پیامک (ارسال بدون الگو)',
      'slug': 'melipayamak',
      'category': 2,
      'accessConfig': true,
      'config': [
        {
          'id': 1,
          'name': 'sms_meli_payamak_username',
          'type': 'text',
          'order': 0,
          'label': 'نام کاربری',
        },
        {
          'id': 2,
          'name': 'sms_meli_payamak_password',
          'type': 'password',
          'order': 1,
          'label': 'کلمه عبور',
        },
        {
          'id': 3,
          'name': 'sms_meli_payamak_number',
          'type': 'text',
          'order': 2,
          'label': 'شماره خط پیامکی',
        },
      ],
      'values': [
        {
          'id': 1,
          'value': system.settings.sms_meli_payamak_username,
        },
        {
          'id': 2,
          'value': system.settings.sms_meli_payamak_password,
        },
        {
          'id': 3,
          'value': system.settings.sms_meli_payamak_number,
        },
      ],
      'website': 'https://www.melipayamak.com/',
      'excerpt': 'یکی از سرویس دهندگان معتبر سامانه های پیامکی در کشور ملی پیامک است که به عنوان یکی از افزونه های پیامکی در هلپیکال در اختیار شما قرار خواهد داشت.',
      'configuration': 'برای فعال سازی افزونه ملی پیامک، اطلاعات زیر را طبق جزئیات پنل پیامکی خود وارد نموده و دکمه ثبت اطلاعات را بفشارید. پس از این کار، می توانید سرویس ملی پیامک را در بخش تنظیمات عمومی از قسمت اطلاع رسانی سامانه هلپیکال انتخاب نمایید.',
      'description': 'یکی از ارائه دهندگان معتبر سرویس های پیامکی در کشور را می توان ملی پیامک دانست. سامانه ملی پیامک می تواند از طریق ابزار وب سرویس خود، به عنوان یک ابزار مکمل در کنار نرم افزار سازمانی هلپیکال ایفای نقش کند و در اجرای عملیات اطلاع رسانی رویدادهای هلپیکال حضور داشته باشد. اگر سامانه پیامکی خود را از ملی پیامک تهیه کرده اید می توانید به راحتی از استفاده از ارتباط این دو نرم افزار اطمینان داشته باشید.<br /><br /> <span class="font-weight-bold">قیمت افزونه: رایگان</span>',
      'permissions': 'افزونه ملی پیامک برای ارسال اطلاعیه های پیامکی سامانه هلپیکال به اطلاعات زیر در پایگاه داده دسترسی خواهد داشت.\n\n-	اطلاعات کاربری مشتریان، کاربران سازمانی و مدیران\n- جزئیات تیکت ها'
    },
    {
      'icon': pluginKavenegar,
      'name': 'کاوه نگار (ارسال بدون الگو)',
      'slug': 'kavehnegar',
      'category': 2,
      'accessConfig': true,
      'config': [
        {
          'id': 1,
          'name': 'sms_kavenegar_token',
          'type': 'password',
          'order': 1,
          'label': 'توکن',
        },
        {
          'id': 2,
          'name': 'sms_kavenegar_from',
          'type': 'text',
          'order': 2,
          'label': 'شماره خط پیامکی',
        },
      ],
      'values': [
        {
          'id': 1,
          'value': system.settings.sms_kavenegar_token,
        },
        {
          'id': 2,
          'value': system.settings.sms_kavenegar_from,
        },
      ],
      'website': 'https://kavenegar.com/',
      'excerpt': 'کاوه نگار یکی دیگر از افزونه های پیامکی موجود در نرم افزار هلپیکال است که به دارندگان این سرویس امکان اتصال هلپیکال به این سرویس را فراهم می کند.',
      'configuration': 'برای فعال سازی افزونه پیامکی کاوه نگار در سامانه هلپیکال، در تنظیمات کاوه نگار یک کلید API یا توکن ایجاد کرده و سپس آنرا در این صفحه وارد نمایید. علاوه بر این مورد، شماره خط پیامکی ای که قرار است ارسال از آن صورت پذیرد را نیز در این صفحه وارد کنید. پس از این کار، می توانید سرویس کاوه نگار را در بخش تنظیمات عمومی از قسمت اطلاع رسانی سامانه هلپیکال انتخاب نمایید.',
      'description': 'مجموعه کاوه نگار یکی دیگر از شرکت های فعال در زمینه ارائه خدمات پیامکی است که مجموعه های مختلفی را در طیف مشتریان خود در اختیار دارد. با توجه به استفاده گسترده مجموعه های مختلف از خدمات این سرویس دهنده، افزونه یکپارچه سازی شده هلپیکال با این سامانه پیامکی نیز در اختیار شما قرار گرفته است.<br /><br /> <span class="font-weight-bold">قیمت افزونه: رایگان</span>',
      'permissions': 'افزونه پیامکی کاوه نگار برای ارسال اطلاعیه های پیامکی سامانه هلپیکال به اطلاعات زیر در پایگاه داده دسترسی خواهد داشت.\n\n- اطلاعات کاربری مشتریان، کاربران سازمانی و مدیران\n- جزئیات تیکت ها'
    },
    {
      'icon': pluginSmsir,
      'name': 'SMS.ir (ارسال بدون الگو)',
      'slug': 'smsir',
      'category': 2,
      'accessConfig': true,
      'config': [
        {
          'id': 1,
          'name': 'sms_sms_ir_api_key',
          'type': 'password',
          'order': 0,
          'label': 'کلید API',
        },
        {
          'id': 2,
          'name': 'sms_sms_ir_line_number',
          'type': 'text',
          'order': 1,
          'label': 'شماره خط پیامکی',
        },
      ],
      'values': [
        {
          'id': 1,
          'value': system.settings.sms_sms_ir_api_key,
        },
        {
          'id': 2,
          'value': system.settings.sms_sms_ir_line_number,
        },
      ],
      'website': 'https://sms.ir',
      'excerpt': 'گر جزو دارندگان سرویس های پیامکی از وب سایت sms.ir هستید، می توانید با استفاده از این افزونه به راحتی پنل پیامکی خود را به هلپیکال متصل نمایید.',
      'configuration': 'برای فعال سازی افزونه پیامکی SMS.IR در سامانه هلپیکال، در تنظیمات پنل پیامکی خود، یک کلید API ایجاد کرده و سپس آنرا در این صفحه وارد نمایید. علاوه بر این مورد، شماره خط پیامکی ای که قرار است ارسال از آن صورت پذیرد را نیز در این صفحه وارد کنید. پس از این کار، می توانید سرویس SMS.IR را در بخش تنظیمات عمومی از قسمت اطلاع رسانی سامانه هلپیکال انتخاب نمایید.',
      'description': 'مجموعه ایده پردازان را می توان یکی از شرکت های فعال در زمینه ارائه خدمات در حوزه نرم افزار و فناوری اطلاعات دانست. این مجموعه با ارائه سرویس پیامکی ذیل برند SMS.IR توانسته است به یکی از برندهای شناخته شده در حوزه این دسته از خدمات تبدیل شود. از این رو، یکپارچه سازی سامانه سازمانی هلپیکال با این سرویس در قالب این افزونه به شما ارائه گردیده است.<br /><br /> <span class="font-weight-bold">قیمت افزونه: رایگان</span>',
      'permissions': 'افزونه پیامکی SMS.IR برای ارسال اطلاعیه های پیامکی سامانه هلپیکال به اطلاعات زیر در پایگاه داده دسترسی خواهد داشت.\n\n-	اطلاعات کاربری مشتریان، کاربران سازمانی و مدیران\n- جزئیات تیکت ها'
    },
    {
      'icon': pluginMagfa,
      'name': 'مگفا (ارسال بدون الگو)',
      'slug': 'magfa',
      'category': 2,
      'accessConfig': true,
      'config': [
        {
          'id': 1,
          'name': 'sms_magfa_username',
          'type': 'text',
          'order': 0,
          'label': 'نام کاربری',
        },
        {
          'id': 2,
          'name': 'sms_magfa_password',
          'type': 'password',
          'order': 1,
          'label': 'کلمه عبور',
        },
        {
          'id': 3,
          'name': 'sms_magfa_number',
          'type': 'text',
          'order': 2,
          'label': 'شماره خط پیامکی',
        },
        {
          'id': 4,
          'name': 'sms_magfa_domain',
          'type': 'text',
          'order': 3,
          'label': 'دامنه',
        },
      ],
      'values': [
        {
          'id': 1,
          'value': system.settings.sms_magfa_username,
        },
        {
          'id': 2,
          'value': system.settings.sms_magfa_password,
        },
        {
          'id': 3,
          'value': system.settings.sms_magfa_number,
        },
        {
          'id': 4,
          'value': system.settings.sms_magfa_domain,
        },
      ],
      'website': 'https://messaging.magfa.com',
      'excerpt': 'مگفا اپراتور اصلی سرویس پیام کوتاه با سرشماره 3000 است که بسیاری از سازمان های دولتی و شرکت های خصوصی از خدمات آن استفاده می کنند.',
      'configuration': 'برای فعال سازی افزونه پیامکی مگفا، اطلاعات زیر را طبق جزئیات دریافت شده از این شرکت وارد نموده و دکمه ثبت اطلاعات را بفشارید. پس از این کار، می توانید سرویس مگفا را در بخش تنظیمات عمومی از قسمت اطلاع رسانی سامانه هلپیکال انتخاب نمایید.',
      'description': 'مگفا اپراتور اصلی سرویس پیام کوتاه با سرشماره 3000 است که بسیاری از سازمان های دولتی و شرکت های خصوصی از خدمات آن استفاده می کنند. کیفیت ارسال، نرخ قیمتی مناسب و ویژگی های متعدد دیگری را می توان دلیل انتخاب این اپراتور توسط مجموعه های مختلف برای سرویس های مبتنی بر پیام کوتاه دانست. اگر پیش از این سرویس پیامکی خود را به صورت مستقیم از مجموعه مگفا تهیه کرده اید، می توانید به راحتی در قسمت پیکربندی، با انجام تنظیماتی ساده، هلپیکال را به سرویس پیامکی خود متصل نمایید.<br /><br /> <span class="font-weight-bold">قیمت افزونه: رایگان</span>',
      'permissions': 'افزونه مگفا برای ارسال اطلاعیه های پیامکی سامانه هلپیکال به اطلاعات زیر در پایگاه داده دسترسی خواهد داشت.\n\n-	اطلاعات کاربری مشتریان، کاربران سازمانی و مدیران\n- جزئیات تیکت ها'
    },
    {
      'icon': pluginUrl,
      'name': 'ارسال SMS از طریق URL (ارسال بدون الگو)',
      'slug': 'urlbase',
      'category': 2,
      'accessConfig': true,
      'config': [
        {
          'id': 1,
          'name': 'sms_url_base_url',
          'type': 'text',
          'order': 0,
          'label': 'آدرس URL',
        },
      ],
      'values': [
        {
          'id': 1,
          'value': system.settings.sms_url_base_url,
        },
      ],
      'excerpt': 'اگر امکان استفاده از ارسال پیامک بر پایه URL را دارید، هم اکنون می توانید هلپیکال را به پنل پیامکی خود متصل نمایید.',
      'configuration': 'برای فعال سازی افزونه ارسال پیامک مبتنی بر URL، لطفا اطلاعات لازم که تشکیل دهنده درخواست شما هستند را در کادر زیر درج نمایید. این اطلاعات می باید الگوی دریافتی شما از شرکت ارائه دهنده خدمات پیامکی باشد. صرفاً دقت کنید که پس از دریافت الگو از شرکت مربوطه، می باید مقدار مرتبط با شماره گیرنده را در کادر زیر معادل {{number}} و مقدار متن ارسالی را {{text}} قرار دهید.<br/>نمونه (دقت نمایید که این مثال ممکن است مطابق با الگوی سرویس دهنده شما نباشد):<br/>https://smsprovider.ir/byurl/?username=USERNAME&password=PASSWORD&from=1000&message={{text}}&to={{number}}',
      'description': 'یکی از روش های ارسال پیامک برای دوری از تنظیمات مختلف اپراتورهای مختلف، ارسال بر پایه URL است. در این روش مقادیر لازم جهت ارسال پیامک در یک رشته متنی تعبیه شده و به سمت اپراتور پیامکی ارسال می گردد. اگر قصد دارید از این روش استفاده نمایید، کافی است تا با شرکت تأمین کننده خدمات پیامکی خود در ارتباط بوده و الگوی صحیح استفاده از این روش را دریافت نمایید و سپس، طبق اطلاعات حساب کاربری و تنظیمات پنل پیامکی خود اقدام به پیکربندی این افزونه در هلپیکال نمایید.<br /><br /> <span class="font-weight-bold">قیمت افزونه: رایگان</span>',
      'permissions': 'افزونه ارسال پیامک بر پایه URL برای ارسال اطلاعیه های پیامکی سامانه هلپیکال به اطلاعات زیر در پایگاه داده دسترسی خواهد داشت.\n\n-	اطلاعات کاربری مشتریان، کاربران سازمانی و مدیران\n- جزئیات تیکت ها'
    },
    {
      'icon': pluginCrisp,
      'name': 'Crisp',
      'slug': 'crisp',
      'category': 4,
      'accessConfig': true,
      'config': [],
      'values': [],
      'website': 'https://crisp.chat',
      'excerpt': 'نرم افزار Crisp را می توان یکی از محبوب ترین ابزارهای چت آنلاین خارجی که در وب سایت های ایرانی مورد استفاده قرار گرفته است دانست.',
      'configuration': 'برای نصب و استفاده از این افزونه، <a target="_blank" class="text-secondary font-bold text-decoration-none" href="https://chromewebstore.google.com/detail/helpical-crisp/fbnjipchbniidfkpkhkiokedjninhpgh">اینجا کلیک کنید</a> تا وارد Chrome Store شوید. سپس دکمه Add to Chrome را کلیک کنید تا افزونه بر روی مرورگر شما نصب شود. حال مراحل زیر را انجام دهید:<br>1- از بخش Extensions در مرورگر Chrome افزونه هلپیکال را پیدا کرده و آن را به نوار ابزار مرورگر Pin کنید (اختیاری)<br>2- روی آیکون افزونه در نوار ابزار کلیک کرده و آدرس سامانه تیکتینگ هلپیکال که لایسنس شما بر روی آن فعال است را در کادر مربوطه وارد نمایید. سپس گزینه Save URL را کلیک کنید.<br>3- افزونه هم اکنون برای شما نصب شده است. از این پس در صفحه مکالمات در محیط اپراتورهای چت آنلاین، دکمه جدیدی برای هدایت همکاران شما به صفحه "ثبت تیکت از طرف مشتری" در نرم افزار هلپیکال به نمایش در خواهد آمد.<br>(این تنظیمات توسط کاربرانی که قصد استفاده از این افزونه را دارند باید صورت پذیرد).',
      'description': 'نرم افزار Crisp را می توان یکی از محبوب ترین ابزارهای چت آنلاین خارجی که در وب سایت های ایرانی مورد استفاده قرار گرفته است دانست. با استفاده از این افزونه در بستر مرورگر Google Chrome، می توانید در صورت نیاز به پیگیری های بیشتر و دقیق تر برای کاربرانی که در محیط چت با آنها در ارتباط هستید، به راحتی یک کلیک وارد محیط نرم افزار هلپیکال شده و از طرف آن مشتری ثبت تیکت نمایید. دقت کنید که این مشتری می باید از قبل در نرم افزار هلپیکال تعریف شده و شماره موبایل یا آدرس ایمیل خود را در محیط چت وارد نموده باشد.<br /><br /> <span class="font-weight-bold">قیمت افزونه: رایگان</span>',
      'permissions': 'این افزونه برای عملیات شناسایی مشتریان در بستر نرم افزار هلپیکال، به شماره موبایل یا آدرس ایمیل کاربران در پنل چت آنلاین دسترسی خواهد داشت.'
    },
    {
      'icon': pluginRaychat,
      'name': 'رایچت',
      'slug': 'raychat',
      'category': 4,
      'accessConfig': true,
      'config': [],
      'values': [],
      'website': 'https://raychat.io',
      'excerpt': 'نرم افزار رایچت یکی از ابزارهای نام آشنای کشور در زمینه چت آنلاین هست که بسیاری از وب سایت ها برای ارتباط اولیه با مشتریان از آن استفاده می کنند.',
      'configuration': 'برای نصب و استفاده از این افزونه، <a target="_blank" class="text-secondary font-bold text-decoration-none" href="https://chromewebstore.google.com/detail/helpical-raychat/mainhmcjdfmhmiiojnlpombennhiaafh">اینجا کلیک کنید</a> تا وارد Chrome Store شوید. سپس دکمه Add to Chrome را کلیک کنید تا افزونه بر روی مرورگر شما نصب شود. حال مراحل زیر را انجام دهید:<br>1- از بخش Extensions در مرورگر Chrome افزونه هلپیکال را پیدا کرده و آن را به نوار ابزار مرورگر Pin کنید (اختیاری)<br>2- روی آیکون افزونه در نوار ابزار کلیک کرده و آدرس سامانه تیکتینگ هلپیکال که لایسنس شما بر روی آن فعال است را در کادر مربوطه وارد نمایید. سپس گزینه Save URL را کلیک کنید.<br>3- افزونه هم اکنون برای شما نصب شده است. از این پس در صفحه مکالمات در محیط اپراتورهای چت آنلاین، دکمه جدیدی برای هدایت همکاران شما به صفحه "ثبت تیکت از طرف مشتری" در نرم افزار هلپیکال به نمایش در خواهد آمد.<br>(این تنظیمات توسط کاربرانی که قصد استفاده از این افزونه را دارند باید صورت پذیرد).',
      'description': 'نرم افزار رایچت یکی از ابزارهای نام آشنای کشور در زمینه چت آنلاین هست که بسیاری از وب سایت ها برای ارتباط اولیه با مشتریان از آن استفاده می کنند. با استفاده از این افزونه در بستر مرورگر Google Chrome، می توانید در صورت نیاز به پیگیری های بیشتر و دقیق تر برای کاربرانی که در محیط چت با آنها در ارتباط هستید، به راحتی یک کلیک وارد محیط نرم افزار هلپیکال شده و از طرف آن مشتری ثبت تیکت نمایید. دقت کنید که این مشتری می باید از قبل در نرم افزار هلپیکال تعریف شده و شماره موبایل یا آدرس ایمیل خود را در محیط چت وارد نموده باشد.<br /><br /> <span class="font-weight-bold">قیمت افزونه: رایگان</span>',
      'permissions': 'این افزونه برای عملیات شناسایی مشتریان در بستر نرم افزار هلپیکال، به شماره موبایل یا آدرس ایمیل کاربران در پنل چت آنلاین دسترسی خواهد داشت.'
    },
    {
      'icon': pluginGoftino,
      'name': 'گفتینو',
      'slug': 'goftino',
      'category': 4,
      'accessConfig': true,
      'config': [],
      'values': [],
      'website': 'https://www.goftino.com',
      'excerpt': 'گفتینو یکی از پرکاربردترین نرم افزارهای چت آنلاین در کشور است که وب سایت های متعددی برای پاسخگویی اولیه به کاربران خود از آن استفاده می کنند.',
      'configuration': 'برای نصب و استفاده از این افزونه، <a target="_blank" class="text-secondary font-bold text-decoration-none" href="https://chromewebstore.google.com/detail/helpical-goftino/moembfemmiappalhcpfogjlalmbnbdmh">اینجا کلیک کنید</a> تا وارد Chrome Store شوید. سپس دکمه Add to Chrome را کلیک کنید تا افزونه بر روی مرورگر شما نصب شود. حال مراحل زیر را انجام دهید:<br>1- از بخش Extensions در مرورگر Chrome افزونه هلپیکال را پیدا کرده و آن را به نوار ابزار مرورگر Pin کنید (اختیاری)<br>2- روی آیکون افزونه در نوار ابزار کلیک کرده و آدرس سامانه تیکتینگ هلپیکال که لایسنس شما بر روی آن فعال است را در کادر مربوطه وارد نمایید. سپس گزینه Save URL را کلیک کنید.<br>3- افزونه هم اکنون برای شما نصب شده است. از این پس در صفحه مکالمات در محیط اپراتورهای چت آنلاین، دکمه جدیدی برای هدایت همکاران شما به صفحه "ثبت تیکت از طرف مشتری" در نرم افزار هلپیکال به نمایش در خواهد آمد.<br>(این تنظیمات توسط کاربرانی که قصد استفاده از این افزونه را دارند باید صورت پذیرد).',
      'description': 'گفتینو یکی از پرکاربردترین نرم افزارهای چت آنلاین در کشور است که وب سایت های متعددی برای پاسخگویی اولیه به کاربران خود از آن استفاده می کنند. با استفاده از این افزونه در بستر مرورگر Google Chrome، می توانید در صورت نیاز به پیگیری های بیشتر و دقیق تر برای کاربرانی که در محیط چت با آنها در ارتباط هستید، به راحتی یک کلیک وارد محیط نرم افزار هلپیکال شده و از طرف آن مشتری ثبت تیکت نمایید. دقت کنید که این مشتری می باید از قبل در نرم افزار هلپیکال تعریف شده و شماره موبایل یا آدرس ایمیل خود را در محیط چت وارد نموده باشد.<br /><br /> <span class="font-weight-bold">قیمت افزونه: رایگان</span>',
      'permissions': 'این افزونه برای عملیات شناسایی مشتریان در بستر نرم افزار هلپیکال، به شماره موبایل یا آدرس ایمیل کاربران در پنل چت آنلاین دسترسی خواهد داشت.'
    },
  ];
}
